import { ReactNode } from "react";

import { cn } from "./cn";

interface Props {
  children: ReactNode;
  variant?: "box" | "plain";
  as?: "p" | "div";
  className?: string;
}

const VARIANT = {
  box: "rounded-lg border border-dashed border-border px-4 py-6",
  plain: "py-6",
} as const;

// 목록이 비었을 때의 안내 — box 는 점선 상자, plain 은 이미 테두리가 있는 카드 안쪽용.
const EmptyState = ({ children, variant = "box", as: Tag = "p", className }: Props) => (
  <Tag className={cn(VARIANT[variant], "text-center text-sm text-muted-foreground", className)}>{children}</Tag>
);

// 표가 비었을 때의 한 줄 — Table 이든 원시 table 이든 들어가도록 tr·td 로 그린다.
export const EmptyRow = ({ colSpan, children }: { colSpan: number; children: ReactNode }) => (
  <tr>
    <td className="px-3 py-8 text-center text-sm text-muted-foreground" colSpan={colSpan}>
      {children}
    </td>
  </tr>
);

export default EmptyState;
